import React, { useState, useEffect } from 'react'
import styles from './TextAlignInput.module.css'
import {
  SvgAlignLeft,
  SvgAlignCenter,
  SvgAlignRight,
} from '../../../../../../../components/svg/SvgComponents'

const TextAlignInput = ({ value, onChange }) => {
  const [selectedAlign, setSelectedAlign] = useState('')

  useEffect(() => {
    setSelectedAlign(value)
  }, [value])

  const alignPossibilities = [
    { align: 'flex-start', icon: <SvgAlignLeft /> },
    { align: 'center', icon: <SvgAlignCenter /> },
    { align: 'flex-end', icon: <SvgAlignRight /> },
  ]

  const handleAlignChange = (align) => {
    setSelectedAlign(align)
    onChange(align)
  }

  return (
    <div className={styles.container}>
      {alignPossibilities.map(({ align, icon }) => (
        <div
          key={align}
          className={`${styles.button__container} ${
            selectedAlign === align ? styles.active : ''
          }`}
          onClick={() => handleAlignChange(align)}
        >
          {icon}
        </div>
      ))}
    </div>
  )
}

export default TextAlignInput
